import React from "react";

const Banner = () => {
  return (
    <img src="https://i.ibb.co/x2WXpYN/Trx-Banner.png" class="banner"></img>
  );
};

export default Banner;
